import { render, staticRenderFns } from "./sync-page.vue?vue&type=template&id=8f76f328&scoped=true&"
import script from "./sync-page.vue?vue&type=script&lang=js&"
export * from "./sync-page.vue?vue&type=script&lang=js&"
import style0 from "./sync-page.vue?vue&type=style&index=0&id=8f76f328&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f76f328",
  null
  
)

export default component.exports